import {
  ExpandedDetailsSection,
  Flex,
  TestLineageNavButton,
} from '@elementary/common-ui/components';
import { TestResult } from '@elementary/common-ui/types';
import { Stack, Typography } from '@mui/material';
import AdditionalActionsButton from './AdditionalActionsButton';
import OpenTestRunsButton from './OpenTestRunsButton';

const ErrorExpandedRow = ({
  rowData,
  showWidgetButtons,
}: {
  rowData: TestResult;
  showWidgetButtons: boolean;
}) => (
  <Stack sx={{ gap: 2 }}>
    <Flex sx={{ justifyContent: 'space-between' }}>
      <Typography
        sx={{
          fontSize: '13px',
          backgroundColor: 'common.gray3',
          color: 'common.gray2',
          padding: '8px 16px',
          borderRadius: 2,
        }}
      >
        No results - Error in test run
      </Typography>
      {showWidgetButtons && (
        <Flex gap={1}>
          <OpenTestRunsButton
            urlParam={rowData.metadata.elementary_unique_id}
          />
          {!!rowData.metadata.model_unique_id && (
            <TestLineageNavButton
              modelId={rowData.metadata.model_unique_id}
              testName={rowData.metadata.test_name}
            />
          )}
          <AdditionalActionsButton
            elementaryUniqueId={rowData.metadata.elementary_unique_id}
          />
        </Flex>
      )}
    </Flex>
    <ExpandedDetailsSection data={rowData} />
  </Stack>
);

export default ErrorExpandedRow;
